import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Checkbox,
  Link,
  Flex,
  useToast,
  VStack,
  Box,
  Text
} from "@chakra-ui/react";
import { cqAPI } from "../../lib/Auth";


export default function AgreementModal({ agreements = [], onDone, onError }) {
  const toast = useToast();
  const [checkedState, setCheckedState] = useState(
    () => agreements.map(() => false)
  );

  const allChecked = checkedState.every((c) => c === true);

  const toggleCheckbox = (idx) => {
    setCheckedState((prev) => {
      const copy = [...prev];
      copy[idx] = !copy[idx];
      return copy;
    });
  };

  const handleAgree = async () => {
    try {
      if (!allChecked) {
        return toast({
          title: "Error",
          description: "To proceed, review and accept by selecting the checkbox.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      const idsToSend = agreements
        .map((agr, idx) => ({ id: agr._id, checked: checkedState[idx] }))
        .filter((x) => x.checked)
        .map((x) => x.id);

      // double check again if all the ids exist here
      if (idsToSend.length !== agreements.length) {
        return toast({
          title: "Error",
          description: "To proceed, review and accept by selecting the checkbox.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      const response = await cqAPI.post("/agreements", { agreement_ids: idsToSend });
      if (response.type === "error") {
        toast({
          title: "Error",
          description: response.msg || "Failed to accept agreement.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return onError();
      }
      console.log('reached here');
      return onDone();
    } catch (err) {
      toast({
        title: "Error",
        description: "Something Went Wrong!",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      onError();
    }
  };

  return (<Modal isOpen={true} onClose={() => {
  }} closeOnOverlayClick={false}>
    <ModalOverlay
      bg='blackAlpha.300'
      backdropFilter='blur(10px) hue-rotate(90deg)'
    />
    <ModalContent>
      <ModalHeader fontWeight='bold' textAlign="center">User Agreement</ModalHeader>
      <ModalBody textAlign="center">
        <Text textAlign="center" mb={4}>
          Review and accept to access the platform.
        </Text>
        <VStack spacing={3} align="start">
          {agreements.map((agreement, idx) => (
            <Flex key={agreement._id} alignItems={'start'} flexDirection={'row'}>
              <Checkbox
                isChecked={checkedState[idx]}
                onChange={() => toggleCheckbox(idx)}
                pr={2}
                pt={1}
              />
              <Box align={'start'}>
                <Text alignSelf={'start'} as="span">{agreement.custom_msg || "I agree to the"} </Text>
                <Link
                  href={agreement.link || "#"}
                  isExternal
                  color="blue.500"
                  fontWeight="bold"
                  target="_blank"
                  variant="underline"
                >
                  {agreement.name}
                </Link>
              </Box>
            </Flex>

          ))}
        </VStack>
      </ModalBody>
      <ModalFooter alignSelf='center'>
        <Button
          onClick={handleAgree}
          opacity={allChecked ? 1 : 0.5}
          cursor={allChecked ? "pointer" : "not-allowed"}>
          Agreed
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>);
}
